import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ClientSideUtility } from '../../Shared/service/ClientSideUtility';
import { AuthenticationBase } from '../../Shared/service/Authentication';

@Component({

  templateUrl: "../view/Home.html"

})

export class HomeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private clientUtility: ClientSideUtility,
              private authenticationService:AuthenticationBase) {
  }

  ngOnInit(){

    this.clientUtility.minimizeLeftAside();
    if(this.authenticationService.isAuthenticated){
      this.router.navigate(['/Reports/Dashboard']);
    }    
  }

  login():void{    
    this.authenticationService.login();
  }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Home/component/Home.ts